import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";


import {
  FieldWrapper,
  Input,
  InputGroup,
  Label,
  SelectInput,
  TextArea,
  Checkbox,
  Radio,
  RadioGroup,
  // AddBtn,
  // FilterBtn,
  MdOutlineFilterList,
  // FilterContainer
} from "../../Components/Styles/InputStyle2";


import Images from "../../Images";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
// import Tables from "../../Components/AdminStaff/Tables";
import Tables from "../../Components/NewStaff/Table";
// import AddStaff from "../../Components/AdminStaff/AddStaff";
import { toast } from "react-toastify";
// import EditStaff from "../../Components/AdminStaff/EditStaff";
// import DeactivateStaff from "../../Components/AdminStaff/DeactivateStaff";
import { MenuItem, Select } from "@mui/material";
import Navbar from "../../Components/Navbar";
import SummaryCards from "../../Components/NewStaff/SummaryCard";
import { MdFilterList } from "react-icons/md";
import FilterSection from "../../Components/NewStaff/FilterSection";
// import LinkUnlink from "../../Components/AdminStaff/LinkUnlink";
// import Summary from "../../Components/AdminStaff/Summary";

const NewStaff = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState(1);
  const [apiData, setApiData] = useState();
  const [isAddStaff, setIsAddStaff] = useState(false);
  const [isEditStaff, setIsEditStaff] = useState(false);
  const [isDeactivateStaff, setIsDeactivateStaff] = useState(false);
  const [linkStaff, setLinkStaff] = useState(false);
  const [isStaffSummary, setIsStaffSummary] = useState(false);
  const [filter, setFilter] = useState("");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };
  const { t, i18n } = useTranslation();

  const [summary, setSummary] = useState({
    monthlyData: {
      dueTenantCount: 44,
      month: 2,
      year: 2025,
      totalIncome: 0,
      totalDues: 1350249,
      totalSecurity: 0,
      totalOffline: 0,
      totalOnline: 0,
    },
    totalYearlyRent: 129297,
    totalYearlySecurity: 0,
  });
  const onSummaryBoxClick = (data) => {
    setFilter(data);
  };
  // const property = useSelector(
  //     (state) => state.SelectPropertyReducer.selectProperty
  // );

  // const propertyList = useSelector((state) => state.PropertyReducer.property);

  // const query = `propId=${property?.id}&filter=${filterValue}&s=`;

  // const fetchFunction = async () => {
  //     const response = await axios.get(
  //         `${Config.apiUrl}/staff/list/web?${query}`,
  //         {
  //             headers: {
  //                 authorization: "Bearer" + " " + user.token,
  //                 "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  //             },
  //         }
  //     );
  //     return response.data;
  // };

  // const getSuccess = (res) => {
  //     if (res.isSuccess === false) error = true;
  //     else {
  //         setApiData(res?.data);
  //     }
  // };

  // const getError = (res) => { };

  // const {
  //     isLoading: isLoading,
  //     mutate: getListMutate,
  //     error,
  //     data,
  //     isRefetching,
  // } = useMutation(fetchFunction, {
  //     onSuccess: getSuccess,
  //     onError: getError,
  // });

  // useEffect(() => {
  //     const handler = setTimeout(() => {
  //         getListMutate();
  //     }, 500);

  //     return () => {
  //         clearTimeout(handler);
  //     };
  // }, [property, filterValue]);

  //------- Add Staff -------
  //   const addStaffFunction = async (values) => {
  //     return await axios.post(`${Config.apiUrl}/staff/add`, values, {
  //       headers: {
  //         authorization: "Bearer" + " " + user.token,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //   };

  //   const onAddStaffSuccess = (data) => {
  //     if (data?.data?.isSuccess === true) {
  //       toast.success(data?.data?.msg || "Success");
  //       setIsAddStaff(false);
  //       getListMutate();
  //     } else {
  //       toast.error(data?.rdata?.msg || "An Error Occured");
  //     }
  //   };

  //   const onAddStaffError = (data) => {
  //     toast.error(data?.response?.data?.msg || "An Error Occured");
  //   };

  //   const { isLoading: addStaffLoading, mutate: addStaffMutate } = useMutation(
  //     addStaffFunction,
  //     {
  //       onSuccess: onAddStaffSuccess,
  //       onError: onAddStaffError,
  //     }
  //   );

  //------- Edit Staff -------
  //   const editStaffFunction = async (values) => {
  //     return await axios.post(`${Config.apiUrl}/staff/edit`, values, {
  //       headers: {
  //         authorization: "Bearer" + " " + user.token,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //   };
  //   const onEditStaffSuccess = (data) => {
  //     if (data?.data?.isSuccess === true) {
  //       toast.success(data?.data?.msg || "Success");
  //       setIsEditStaff(false);
  //       getListMutate();
  //     } else {
  //       toast.error(data?.rdata?.msg || "An Error Occured");
  //     }
  //   };

  //   const onEditStaffError = (data) => {
  //     toast.error(data?.response?.data?.msg || "An Error Occured");
  //   };

  //   const { isLoading: editStaffLoading, mutate: editStaffMutate } = useMutation(
  //     editStaffFunction,
  //     {
  //       onSuccess: onEditStaffSuccess,
  //       onError: onEditStaffError,
  //     }
  //   );

  //------- Deactivate/Activate Staff -------
  //   const deactivateStaffFunction = async (values) => {
  //     return await axios.post(`${Config.apiUrl}/staff/toggle/status`, values, {
  //       headers: {
  //         authorization: "Bearer" + " " + user.token,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //   };
  //   const onDeactivateStaffSuccess = (data) => {
  //     if (data?.data?.isSuccess === true) {
  //       toast.success(data?.data?.msg || "Success");
  //       setIsDeactivateStaff(false);
  //       getListMutate();
  //     } else {
  //       toast.error(data?.rdata?.msg || "An Error Occured");
  //     }
  //   };

  //   const onDeactivateStaffError = (data) => {
  //     toast.error(data?.response?.data?.msg || "An Error Occured");
  //   };

  //   const { isLoading: deactivateStaffLoading, mutate: deactivateStaffMutate } =
  //     useMutation(deactivateStaffFunction, {
  //       onSuccess: onDeactivateStaffSuccess,
  //       onError: onDeactivateStaffError,
  //     });

  //------- Link Property Staff -------
  //   const linkPropertyStaffFunction = async (values) => {
  //     return await axios.post(`${Config.apiUrl}/staff/toggle`, values, {
  //       headers: {
  //         authorization: "Bearer" + " " + user.token,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //   };
  //   const onLinkPropertyeStaffSuccess = (data) => {
  //     if (data?.data?.isSuccess === true) {
  //       toast.success(data?.data?.msg || "Success");
  //     } else {
  //       toast.error(data?.rdata?.msg || "An Error Occured");
  //     }
  //   };

  //   const onLinkPropertyStaffError = (data) => {
  //     toast.error(data?.response?.data?.msg || "An Error Occured");
  //   };

  //   const {
  //     isLoading: linkPropertyStaffLoading,
  //     mutate: linkPropertyStaffMutate,
  //   } = useMutation(linkPropertyStaffFunction, {
  //     onSuccess: onLinkPropertyeStaffSuccess,
  //     onError: onLinkPropertyStaffError,
  //   });

  return (
    <>
      <div className="bg-gray-50 min-h-screen">
      <BoxContainer>
        <BoxHead>
          <BoxTitle>
            Attendance
            <Underline />
          </BoxTitle>
          {/* <div className="flex space-x-4">
                        <Select
                            value={filterValue}
                            onChange={(event) => setFilterValue(event.target.value)}
                            displayEmpty
                            sx={{ minWidth: 100 }}
                            className="px-2"
                            style={{ height: "40px" }}
                        >
                            <MenuItem value={1}>Active</MenuItem>
                            <MenuItem value={2}>Inactive</MenuItem>
                        </Select>
                        <ApplyBtn type="button" onClick={() => setIsAddStaff(true)}>
                            Add Staff
                        </ApplyBtn>
                    </div> */}
          <Filters
            // submitHandler={submitHandler}
            initialValues={initialValues}
            // InitialLoading={isLoading}
            // setFilter={setFilter}
            // setFilterValue={setFilterValue}
            // ChangeHandler={ChangeHandler}
            // filterValue={filterValue}
            // filter={filter}
            t={t}
          // setIsAddComplaint={setIsAddComplaint}
          // setIsFilterOpen={setIsFilterOpen}
          />
        </BoxHead>
        {/* {(isLoading || isRefetching) && !isFocused && (
                    <SummarySkeletonLoading count={3} />
                )} */}

        {summary && (
          <SummaryCards summaryData={summary} onClick={onSummaryBoxClick} />
        )}
        {/* <div
          className={`${
            isAddStaff ? "flex" : "hidden"
          } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 z-10 ease-in-out`}
        />
        <div
          className={`${
            isAddStaff ? "translate-x-0" : "translate-x-full"
          } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
        >
          {isAddStaff && (
            <AddStaff
              setIsAddStaff={setIsAddStaff}
              isAddStaff={isAddStaff}
              addStaffLoading={addStaffLoading}
              addStaffMutate={addStaffMutate}
              property={propertyList}
            />
          )}
        </div> */}
        {/* <div
          className={`${
            linkStaff ? "flex" : "hidden"
          } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 z-10 ease-in-out`}
        />
        <div
          className={`${
            linkStaff ? "translate-x-0" : "translate-x-full"
          } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
        >
          {linkStaff && (
            <LinkUnlink
              setLinkStaff={setLinkStaff}
              linkStaff={linkStaff}
              linkPropertyStaffLoading={linkPropertyStaffLoading}
              linkPropertyStaffMutate={linkPropertyStaffMutate}
              property={propertyList}
              selectedData={selectedData}
            />
          )}
        </div> */}
        {/* <div
          className={`${
            isEditStaff ? "flex" : "hidden"
          } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 z-10 ease-in-out`}
        />
        <div
          className={`${
            isEditStaff ? "translate-x-0" : "translate-x-full"
          } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
        >
          {isEditStaff && (
            <EditStaff
              isEditStaff={isEditStaff}
              setIsEditStaff={setIsEditStaff}
              editStaffLoading={editStaffLoading}
              editStaffMutate={editStaffMutate}
              selectedData={selectedData}
              isDeactivateStaff={isDeactivateStaff}
              setIsDeactivateStaff={setIsDeactivateStaff}
            />
          )}
        </div> */}
        {/* {isDeactivateStaff && (
          <DeactivateStaff
            isDeactivateStaff={isDeactivateStaff}
            setIsDeactivateStaff={setIsDeactivateStaff}
            deactivateStaffLoading={deactivateStaffLoading}
            deactivateStaffMutate={deactivateStaffMutate}
            selectedData={selectedData}
          />
        )}
        {isStaffSummary && (
          <Summary
            isStaffSummary={isStaffSummary}
            setIsStaffSummary={setIsStaffSummary}
          />
        )} */}
        <FilterSection />
        {/* {(!isLoading || !isRefetching) && data && ( */}
        <TableWrapper>
          <Tables
            apiData={apiData}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            setIsEditStaff={setIsEditStaff}
            setIsDeactivateStaff={setIsDeactivateStaff}
            setLinkStaff={setLinkStaff}
            setIsStaffSummary={setIsStaffSummary}
          />
          {/* {(error || apiData.length === 0) && !isLoading && <NotFoundModel />}  */}
        </TableWrapper>
        {/* )} */}

        {/* {(isLoading || isRefetching) && <Loading />} */}
      </BoxContainer>
      </div>
    </>
  );
};
const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  t,
  setIsAddComplaint,
  setIsFilterOpen,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={() => { console.log("submitHandler") }}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">{t("Date")}:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field
                type="date"
                name="startDate"
                id="startDate"
                className="ml-1"
                max={today}
              />
            </FieldWrapper>
          </InputGroup>
          <ApplyBtn disabled={InitialLoading} type="submit">
            {"Apply"}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};


const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color h-full rounded-md px-6  cursor-pointer bg-white hover:bg-primary-color hover:text-white  py-2.5 text-sm`;
const BoxContainer = tw.div`max-w-6xl mx-auto bg-gray-50 py-6`;
const BoxHead = tw.div`flex flex-col md:flex-row justify-between md:items-center mb-8 mx-auto gap-4`;
// const BoxTitle = tw.h1`${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}`;
const BoxTitle = tw.h1`justify-center text-xl text-black font-semibold space-x-2 items-center mb-5 rounded-md !mb-0 whitespace-nowrap`;
const Underline = tw.div`w-12 h-0.5 bg-black mt-1.5 rounded-full `;
// const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
// const ApplyBtn = tw.button`${(p) =>
//     p.$active
//         ? "bg-gray-100"
//         : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color h-full rounded-md px-6 cursor-pointer bg-white hover:bg-primary-color hover:text-white py-[.550rem] text-sm`;
const FilterBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color h-full rounded-md px-3  cursor-pointer bg-white hover:bg-primary-color hover:text-white py-[.550rem] text-sm`;
const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 lg:gap-0 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} whitespace-nowrap flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color py-2.5 text-sm`;




export default NewStaff;